import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
export default function DocStatus(param) {
    var statusID = param.statusID, statusName = param.statusName;
    var _useState = _sliced_to_array(useState({
        statusName: statusName,
        statusID: statusID
    }), 2), elemData = _useState[0], setElemData = _useState[1];
    useEffect(function() {
        setElemData({
            statusName: statusName,
            statusID: statusID
        });
    }, [
        statusName,
        statusID
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "".concat(elemData.statusID == "overdue" ? "fs-18" : "fs-20", " doc-container doc-status-").concat(elemData.statusID),
        children: elemData.statusName
    });
}
